<template>
  <router-view />
</template>

<script>
export default {};
</script>

<style type="text/css">
::-webkit-scrollbar {
  width: 7px;
  height: 7px;
}

::-webkit-scrollbar-button {
  width: 0px;
  height: 0px;
}

::-webkit-scrollbar-thumb {
  background: #09518c;
  border: 0px none #ffffff;
  border-radius: 0px;
}

::-webkit-scrollbar-thumb:hover {
  background: #6e143c;
}

::-webkit-scrollbar-thumb:active {
  background: #6e143c;
}

::-webkit-scrollbar-track {
  background: #fff;
  border: 0px none #fff;
  border-radius: 0px;
}

::-webkit-scrollbar-track:hover {
  background: #fff;
}

::-webkit-scrollbar-track:active {
  background: #fff;
}

::-webkit-scrollbar-corner {
  background: transparent;
}
</style>
